// extracted by mini-css-extract-plugin
export default {"spinner-content":"ClaimDepartment_spinner-content__nspHT","spinner":"ClaimDepartment_spinner__SnKIB"};